import { DetailsContainer } from '@/components/DecisionPanelCards/Shared'
import DetailsList from '@/components/DetailsList'
import type { Sanctions } from '@/lib/apollo/query/get-applicant'
import { SanctionsStatus } from '@/lib/apollo/query/get-applicant'
import { formatDate, parseDate } from '@/utils/date'

import { isVerifiedStatus } from './utils'

export interface Props {
  sanctions: Sanctions | null
}

const mapSanctionsStatus = (status?: SanctionsStatus) => {
  switch (status) {
    case SanctionsStatus.MATCH:
      return 'Sanctions Match'
    case SanctionsStatus.NOT_FOUND:
    case SanctionsStatus.MISMATCH:
      return 'Sanctions not found'
    default:
      return 'Sanctions not checked'
  }
}

const SanctionsOverview = ({ sanctions }: Props) => {
  const details = [
    {
      label: 'Status',
      children: mapSanctionsStatus(sanctions?.status),
    },
    ...(isVerifiedStatus(sanctions?.status) && sanctions?.verifiedAt
      ? [
          {
            label: 'Verified At',
            children: formatDate(parseDate(sanctions.verifiedAt), 'dd/MM/yyyy HH:mm'),
          },
        ]
      : []),
  ]

  return (
    <div>
      <h3>Sanctions</h3>
      <DetailsContainer>
        <DetailsList details={details} />
      </DetailsContainer>
    </div>
  )
}

export default SanctionsOverview
